// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"791":"7b60874c","939":"4a968263"}[chunkId] + ".chunk.css";
};